import React from "react";
import { Card } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import './Services.css';

import designbg from '../images/PageImg/ServiceDesign-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { ServDesignTopTxt } from "../assets/ServDesignData";
import { ServDesignPCapImg } from "../assets/ServDesignData";
import { ServDesignPCapTxt } from "../assets/ServDesignData";
import { ServDesignFpcImg } from "../assets/ServDesignData";
import { ServDesignFpcTxt } from "../assets/ServDesignData";
import { ServDesignLamImg } from "../assets/ServDesignData";
import { ServDesignLamTxt } from "../assets/ServDesignData";

import { GoTopBtn } from '../components/GoTopBtn';

function ServiceDesign() {
  // console.log("get into function ServiceDesign()");
  return (
    <div className='services-page container-fluid'>
      <div className='serviceheader'
        style={{ backgroundImage: `url(${designbg})`, height: "auto" }} >
        <HeaderSlide text={'Service / Design'} />
        <h4 className='text-light'>&nbsp;images/PageImg/ServiceDesign-page-bg.jpg</h4>
      </div>
      {/* <br /> */}

      {/* Service Marketing Top Iext */}
      <section id='servdesigntop' className='service-block bg-success-subtle mt-2'>
        <Container fluid className='holder d-flex'> {
          ServDesignTopTxt.map(top => {
            return (
              <Col key={top.id}>
                <br />
                <h2 className='m-1 fs-2 text-center text-primary'>{top.title}</h2>
                <p className='m-1 fs-4' style={{ whiteSpace: 'pre-wrap' }}>{top.text}</p>
              </Col>
            )
          })
        } </Container>
      </section>

      {/* Service / Design PCap Touch*/}
      <section id='servdesignpcap' className='service-block bg-success-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-primary'>Service / Touch Design </h2>
        {/* <Container fluid> */}
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            ServDesignPCapImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '40vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              )
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            // <Row> {
            ServDesignPCapTxt.map((design) => {
              return (
                <Row key={design.id} style={{ marginLeft: '-25px', width: '57.5vw' }}>
                  <Card className='bg-warning-subtle border-1'>
                    <br />
                    <Card.Title className='fs-2 text-center text-primary'> {design.title} </Card.Title>
                    <Card.Text className='fs-2 text-center text-primary'> {design.subtitle} </Card.Text>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {design.text} </Card.Text>
                    {/* <Card.Text className='fs-4' style={{ whiteSpace: 'pre' }}> {pcap.text} </Card.Text> */}
                  </Card>
                </Row>
              )
            })
            // } </Row>
          } </Col>
        </Row>
        {/* </Container> */}
      </section>

      {/* Service / Design FPC */}
      <section id='servdesignfpc' className='service-block bg-primary-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-primary'>Service / FPC Design</h2>
        <Row>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            ServDesignFpcTxt.map((fpc) => {
              return (
                <Row key={fpc.id} className='holder'>
                  <Card className='bg-danger-subtle border-1' style={{ marginLeft: '11px' }}>
                    <br />
                    <Card.Title className='text-center fs-3 text-primary'> {fpc.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {fpc.text} </Card.Text>
                    {/* <Card.Text className='fs-2 text-center text-primary'> {fpc.subtitle} </Card.Text> */}
                  </Card>
                </Row>
              )
            })
          } </Col>
          <Col lg={5} className='flex-column justify-content-center'> {
            ServDesignFpcImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
                  {/* <img style={{ width: '60vw' }} src={idx.image} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              )
            })
          } </Col>
        </Row>
      </section>

      {/* Service / Design Cover+Sensor Laminate */}
      <section id='servdesignlam' className='service-block bg-success-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-primary'>Service / Laminate Design</h2>
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            ServDesignLamImg.map(img => {
              return (
                <Row key={img.id} className='d-flex'>
                  <img src={img.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '50vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{img.alt}</h5>
                </Row>
              )
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            ServDesignLamTxt.map((laminate) => {
              return (
                <Row key={laminate.id} style={{ marginLeft: '-25px', width: '57.5vw' }}>
                  {/* <Row key={tdm.id} className='holder' style={{ marginLeft: '-25px' }}> */}
                  <Card className='bg-secondry-subtle border-1 p-0 m-0'>
                    <br />
                    <Card.Title className='text-center fs-2 text-primary'> {laminate.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {laminate.text} </Card.Text>
                  </Card>
                </Row>
              )
            })
          } </Col>
        </Row>
      </section>

      <div> < GoTopBtn /> </div>
    </div>
  );
}

export default ServiceDesign;

// import ServicesDesignImage from "../images/ServiceImg/ServDesign.jpg";
// import { ServDesignTopImg } from "../assets/ServDesignData";

/*
<div className='designheader-image' style={{ backgroundImage: "../images/PageImg/ServiceDesign-page-bg.jpg" }} >
<div style={{ backgroundImage: "url('../images/PageImg/products-page.jpg')" }}>
</div>
<img src={idx.image} style={{ height: 'auto' }} alt='' />

import { ImageBackground } from 'react-native';
const App = () => (
  <ImageBackground source={require('path/to/your/image.jpg')} style={{ flex: 1 }}>
  // Your content here
  </ImageBackground>
);

import React from 'react';
import ReactDOM from 'react-dom/client';
import background from '/fujiyama.png'

function App() {
  return (
    <div style={{backgroundImage: `url(${background})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
    }}>
      Hello World!
    </div>
  );
}

*/
/* Service Design Header */
/* <Container fluid className='d-flex align-items-center justify-content-center'> */
/*
<Container fluid className='d-flex'>
  <header className='mt-1'>
    <h1 className='servdesign'>Service / Design</h1>
    <h5 className='text-warning'>PageImg/services-page.jpg</h5>
    <h5 className='text-warning'>ServiceImg/DesignTop/ServDesign.jpg</h5>
  </header>
</Container>
*/


/* Service Design Top Image */
/*
<section id='servdesigntop' className='block service-block bg-primary-subtle'>
  <Container fluid>
    <h2 className='title-holder fs-1 fw-bold text-primary'>Service Design</h2>
    <Row className='d-flex justify-content-around'> {
      ServDesignTopImg.map(idx => {
        return (
          <Col lg={3} key={idx.id} className='flex'>
            <img src={idx.image} style={{ height: 'auto', width: '40vw' }} alt='' />
            // <img src={idx.image} style={{ height: '40vh', width: '40vw' }} alt='' />
            <h5 className='text-danger-emphasis'>{idx.alt}</h5>
          </Col>
        )
      })
    } </Row>
  </Container>
</section>
*/

